import React from 'react';
import { Link } from 'gatsby';

import '../../styles/tags/tag-cloud.scss';

const TagCloud = (props) => {
  return (
    <div className="tag-cloud">
      {props.tagEdges.map(({ node }, idx) => (
        <Link
          className="tag-link"
          to={`/tags/${node.data.Slug}`}
          key={`tag-${idx}`}
        >
          <span className="tag-label">{node.data.Label}</span>
          <span className="tag-count">{node.data.Link_Count}</span>
        </Link>
      ))}
    </div>
  );
};

export default TagCloud;